export type DependencyDepthKind = 'Direct' | 'Transitive' | 'Direct + Transitive';

/**
 * Human-readable depth classification for a dependency. `depth` is the minimum path length across roots (snippet
 * roots have depth 0), so a direct dependency can still be reached transitively when `hasTransitivePath` is true.
 */
export const dependencyDepthKind = (depth: number, hasTransitivePath?: boolean): DependencyDepthKind => {
  if (depth > 1) {
    return 'Transitive';
  }

  return hasTransitivePath ? 'Direct + Transitive' : 'Direct';
};
